import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, Clock, MessageCircle, Calendar } from 'lucide-react';
export function FinalCta() {
  return <section id="contacto" className="py-10 md:py-24 bg-navy text-white relative overflow-hidden" data-id="element-69">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-70">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold via-transparent to-transparent" data-id="element-71" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-73">
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-10 text-gold" data-id="element-74">
            CONTÁCTAME AHORA
          </h2>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-6 md:p-12 shadow-2xl mb-6 md:mb-12" data-id="element-75">
            <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-10" data-id="element-76">
              <a href="tel:786-374-5660" className="inline-flex items-center gap-4 bg-gold hover:bg-gold-light text-navy px-10 py-5 rounded-full font-bold text-2xl md:text-3xl whitespace-nowrap transition-all transform hover:scale-105 shadow-lg justify-center" data-id="element-77">
                <Phone className="w-8 h-8" data-id="element-78" />
                786-374-5660
              </a>
            </div>

            <div className="flex flex-col items-center justify-center gap-4 mb-10" data-id="element-79">
              <a href="mailto:anisleyestanque19@gmail.com" className="flex items-center gap-3 text-xl hover:text-gold transition-colors" data-id="element-80">
                <Mail className="w-6 h-6 text-gold" data-id="element-81" />
                anisleyestanque19@gmail.com
              </a>
            </div>

            <div className="border-t border-white/10 pt-8 mt-8" data-id="element-82">
              <h3 className="text-2xl font-serif font-bold mb-2" data-id="element-83">
                ANISLEY ESTANQUE
              </h3>
              <p className="text-gold uppercase tracking-widest text-sm mb-6" data-id="element-84">
                Agente de Seguros Licenciada
              </p>
              <p className="text-lg text-white/80 mb-8" data-id="element-85">
                Vida · Salud · Dental · Visión
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left max-w-2xl mx-auto" data-id="element-86">
                <div className="flex items-center gap-3 bg-navy-light p-4 rounded-xl" data-id="element-87">
                  <MessageCircle className="w-6 h-6 text-gold shrink-0" data-id="element-88" />
                  <span data-id="element-89">Llama, manda mensaje o escribe un email</span>
                </div>
                <div className="flex items-center gap-3 bg-navy-light p-4 rounded-xl" data-id="element-90">
                  <Clock className="w-6 h-6 text-gold shrink-0" data-id="element-91" />
                  <span data-id="element-92">Disponible 7 días a la semana</span>
                </div>
                <div className="flex items-center gap-3 bg-navy-light p-4 rounded-xl" data-id="element-93">
                  <MessageCircle className="w-6 h-6 text-gold shrink-0" data-id="element-94" />
                  <span data-id="element-95">Atención 100% en Español</span>
                </div>
                <div className="flex items-center gap-3 bg-navy-light p-4 rounded-xl" data-id="element-96">
                  <Calendar className="w-6 h-6 text-gold shrink-0" data-id="element-97" />
                  <span data-id="element-98">Inscripciones disponibles todo el año</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}